import { Injectable, inject } from '@angular/core';
import { IRelatedProductsCallback, RelatedProductsService } from '@df/catalog-ui/related-products/related-products.service';
import { IProductDataV3 } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import flattenDeep from 'lodash-es/flattenDeep';

@Injectable({
    providedIn: 'root'
})
export class RelatedEngine {
    private productResource = inject(ProductResource);

    get(sourceIds: number[], callback: IRelatedProductsCallback) {
        callback(
            flattenDeep<number | undefined>(
                this.productResource
                    .toModels(sourceIds, true) // take given produtcs
                    .map(model => {
                        const data = <IProductDataV3>model.data;
                        return data && data.link && data.link.related;
                    })
            ).filter(i => !!i) as number[]
        );
    }
}

RelatedProductsService.registerEngine('related', RelatedEngine);
